import api from '../../api'
import moment from 'moment'

import {
    CREATE_NEW_MARKETSTUDY,
    DELETE_MARKETSTUDY,
    RESET_MARKETSTUDY,
    SET_MARKETSTUDY,
    SET_MARKETSTUDY_ID,
    SET_MARKETSTUDY_DATE_CREATED,
    SET_MARKETSTUDY_DATE_MODIFIED,
    SET_MARKETSTUDY_DIRTYNESS,
    SET_MARKETSTUDY_PARENT_PATH,
    SET_MARKETSTUDY_PATH,
    UPDATE_MARKETSTUDY,
    SET_MARKETSTUDY_APPRAISAL_ID,
    SET_MARKETSTUDY_DESCRIPTION,
    SET_MARKETSTUDY_QUERY_AD_TYPE,
    SET_MARKETSTUDY_QUERY_DISTANCE_KM,
    SET_MARKETSTUDY_QUERY_LIMITDATE,
    SET_MARKETSTUDY_QUERY_STARTDATE,
    SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION,
    SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION,
    SET_MARKETSTUDY_WEIGHING,
    SET_MARKETSTUDY_WEIGHING_AD_DATE,
    SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE,
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD,
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION,
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION,
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE,
    SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE,
    SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS,
    SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER,
    SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA,
    SET_MARKETSTUDY_WEIGHING_LIFT,
    SET_MARKETSTUDY_APPRAISED_POINTS,
    SET_MARKETSTUDY_COMPARABLE_POINTS,
    SET_MARKETSTUDY_REGRESSIONLINE_POINTS,
    SET_MARKETSTUDY_MARKET_VALUE,
    SET_MARKETSTUDY_MARKET_UNIT_VALUE,
    SET_MARKETSTUDY_REALESTATE_APPRAISALS,
    SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT,
    SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT,
    SET_MARKETSTUDY_OFFER_PRODUCTION,
    SET_MARKETSTUDY_OFFER_YEARLY_STOCK,
    SET_MARKETSTUDY_OFFER_TREND,
    SET_MARKETSTUDY_DEMAND_LEVEL,
    SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES,
    SET_MARKETSTUDY_DEMAND_TREND,
    SET_MARKETSTUDY_PRICES_EXPECTANCY,
    SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY,
    SET_MARKETSTUDY_MARKET_CONJUNCTURE,
    SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY,
    SET_MARKETSTUDY_PRICES_MAX,
    SET_MARKETSTUDY_PRICES_MIN,
    SET_MARKETSTUDY_PRICES_MEAN,
    SET_MARKETSTUDY_PRICES_MEDIAN,


} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    appraisal_id: null,
    description: null,
    query_ad_type: null,
    query_distance_km: 1,
    query_limitdate: null,
    query_startdate: null,
    weighing: {
        '0': {
            ad_date: 0,
            property_type: 2,
            quality_of_neighbourhood: 2,
            quality_of_situation: 2,
            quality_of_construction: 2,
            quality_of_realestate: 2,
            adopted_age: 2,
            conservation_status: 5,
            floor_number: 5,
            adopted_area: 2,
            lift: 10
        }
    },
    universal_sample_typical_deviation: {
        '0': {
            Xi_total: null,
            Vu_total: null,
            Vi_total: null,
            Vu2_total: null,
            XiVi_total: null,
            Xi2_total: null,
            Vi2_total: null,

            n: null,
            Vu_average: null,
            V_coef: null,
            Vu2_n: null,
            Vu_n_2: null,
            summation_Vu2_n: null,
            summation_Vu_n_2: null,
            g2: null,
            g: null,
            t: null,
            s: null,
            s2: null,
            r: null,
            m: null,
            na: null,
            t_ms: null,
            s2_nas: null,
            a: null,
            b: null
        }
    },
    representative_sample_typical_deviation: {
        '0': {
            Xi_total: null,
            Vu_total: null,
            Vi_total: null,
            Vu2_total: null,
            XiVi_total: null,
            Xi2_total: null,
            Vi2_total: null,

            limit_upper: null,
            limit_lower: null,

            n: null,
            Vu_max: null,
            Vu_min: null,
            summation_Vu2_n: null,
            summation_Vu_n_2: null,
            g2: null,
            g: null,
            t: null,
            s: null,
            s2: null,
            r: null,
            m: null,
            na: null,
            t_ms: null,
            s2_nas: null,
            a: null,
            b: null
        }
    },
    appraised_points: [],
    comparable_points: [],
    regressionline_points: [],
    market_value: null,
    market_unit_value: null,
    realestate_appraisals: {},
    prices_estimated_yearly_evolution_pct: null,
    market_value_evolution_probability_pct: null,
    offer_production: null,
    offer_yearly_stock: null,
    offer_trend: null,
    demand_level: null,
    demand_speed_of_sales: null,
    demand_trend: null,
    prices_expectancy: null,
    prices_past_cicles_volatility: null,
    market_conjuncture: null,
    market_value_reduction_probability_expectancy: null,
    prices_max: null,
    prices_min: null,
    prices_mean: null,
    prices_median: null,
}

const state = default_state

const actions = {

    CREATE_NEW_MARKETSTUDY: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({key: data.key, path: data.path})
                .then((res) => {
                    const new_created_key = res.key

                    const limitdate = moment(res.date_created, 'x').format('YYYY-MM-DD')
                    const startdate = moment(limitdate).subtract(6, 'months').format('YYYY-MM-DD')

                    commit(SET_MARKETSTUDY_ID, new_created_key)
                    commit(SET_MARKETSTUDY_DATE_CREATED, res.date_created)
                    commit(SET_MARKETSTUDY_DATE_MODIFIED, res.date_modified)
                    commit(SET_MARKETSTUDY_PARENT_PATH, data.parent_path)
                    commit(SET_MARKETSTUDY_PATH, res.path)
                    commit(SET_MARKETSTUDY_QUERY_LIMITDATE, limitdate)
                    commit(SET_MARKETSTUDY_QUERY_STARTDATE, startdate)

                    // console.log('data.appraisal_id: ')
                    // console.log(data.appraisal_id)

                    let realestate_appraisals = {}
                    realestate_appraisals[data.realestate_id] = {}
                    realestate_appraisals[data.realestate_id][data.appraisal_id] = true

                    const obj = {
                        'appraisal_id': data.appraisal_id,
                        'date_created': res.date_created,
                        'date_modified': res.date_modified,
                        'id': new_created_key,
                        'parent_path': data.parent_path,
                        'path': data.path,
                        'query_distance_km': 1,
                        'query_limitdate': limitdate,
                        'query_startdate': startdate,
                        'realestate_appraisals': realestate_appraisals,
                        'weighing': {
                            '0': {
                                ad_date: 0,
                                property_type: 2,
                                quality_of_neighbourhood: 2,
                                quality_of_situation: 2,
                                quality_of_construction: 2,
                                quality_of_realestate: 2,
                                adopted_age: 2,
                                conservation_status: 5,
                                floor_number: 5,
                                adopted_area: 2,
                                lift: 10
                            }
                        }
                    }

                    api.set_value({
                        value: obj,
                        path: data.path + new_created_key,
                        save_timestamp: false
                    }).then((res) => {
                            const object = {}
                            object[new_created_key] = true
                            api.update({
                                object: object,
                                path: data.parent_path,
                                save_timestamp: false
                            }).then(res => resolve({key: new_created_key}))
                        })


                })
        })
    },
    DELETE_MARKETSTUDY: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_marketstudies/contact_key
            api.delete({key: data.key, path: data.path})
                .then((res) => {
                    // delete from contact/contact_key/marketstudies
                    api.delete({key: data.key, path: data.parent_path})
                        .then((res) => {
                            commit(RESET_MARKETSTUDY)

                        }).then(res => resolve({}))
                })

        })

    },
    SET_MARKETSTUDY: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {

            // console.log('set_marketstudy data:')
            // console.log(data)
            return api.get({path: data.path})
                .then((res) => {
                    // console.log(res)
                    commit(SET_MARKETSTUDY, res)
                }).then(res => resolve({}))

        })

    },
    RESET_MARKETSTUDY: ({state, commit, rootState}) => {
        commit(RESET_MARKETSTUDY)
    },
    SET_MARKETSTUDY_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_DATE_CREATED, data)
    },
    SET_MARKETSTUDY_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_DATE_MODIFIED, data)
    },

    SET_MARKETSTUDY_ID: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_ID, data)
    },

    SET_MARKETSTUDY_PATH: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PATH, data)
    },
    UPDATE_MARKETSTUDY: ({state, commit, rootState}, data) => {
        api.update({object: data.object, path: data.path, save_timestamp: true})
            .then((res) => {

                commit(SET_MARKETSTUDY_DATE_MODIFIED, res.date_modified)
                commit(SET_MARKETSTUDY_DIRTYNESS, false)
            })
    },
    SET_MARKETSTUDY_APPRAISAL_ID: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_APPRAISAL_ID, data)
    },
    SET_MARKETSTUDY_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_DESCRIPTION, data)
    },
    SET_MARKETSTUDY_QUERY_AD_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_QUERY_AD_TYPE, data)
    },
    SET_MARKETSTUDY_QUERY_DISTANCE_KM: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_QUERY_DISTANCE_KM, data)
    },
    SET_MARKETSTUDY_QUERY_LIMITDATE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_QUERY_LIMITDATE, data)
    },
    SET_MARKETSTUDY_QUERY_STARTDATE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_QUERY_STARTDATE, data)
    },
    SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION, data)
    },
    SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION, data)
    },
    SET_MARKETSTUDY_WEIGHING: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING, data)
    },
    SET_MARKETSTUDY_WEIGHING_AD_DATE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_AD_DATE, data)
    },
    SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE, data)
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD, data)
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION, data)
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION, data)
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE, data)
    },
    SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE, data)
    },
    SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS, data)
    },
    SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER, data)
    },
    SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA, data)
    },
    SET_MARKETSTUDY_WEIGHING_LIFT: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_WEIGHING_LIFT, data)
    },
    SET_MARKETSTUDY_APPRAISED_POINTS: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_APPRAISED_POINTS, data)
    },
    SET_MARKETSTUDY_COMPARABLE_POINTS: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_COMPARABLE_POINTS, data)
    },
    SET_MARKETSTUDY_REGRESSIONLINE_POINTS: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_REGRESSIONLINE_POINTS, data)
    },
    SET_MARKETSTUDY_MARKET_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_MARKET_VALUE, data)
    },
    SET_MARKETSTUDY_MARKET_UNIT_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_MARKET_UNIT_VALUE, data)
    },
    SET_MARKETSTUDY_REALESTATE_APPRAISALS: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_REALESTATE_APPRAISALS, data)
    },
    SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT, data)
    },
    SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT, data)
    },
    SET_MARKETSTUDY_OFFER_PRODUCTION: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_OFFER_PRODUCTION, data)
    },
    SET_MARKETSTUDY_OFFER_YEARLY_STOCK: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_OFFER_YEARLY_STOCK, data)
    },
    SET_MARKETSTUDY_OFFER_TREND: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_OFFER_TREND, data)
    },
    SET_MARKETSTUDY_DEMAND_LEVEL: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_DEMAND_LEVEL, data)
    },
    SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES, data)
    },
    SET_MARKETSTUDY_DEMAND_TREND: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_DEMAND_TREND, data)
    },
    SET_MARKETSTUDY_PRICES_EXPECTANCY: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_EXPECTANCY, data)
    },
    SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY, data)
    },
    SET_MARKETSTUDY_MARKET_CONJUNCTURE: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_MARKET_CONJUNCTURE, data)
    },
    SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY, data)
    },
    SET_MARKETSTUDY_PRICES_MAX: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_MAX, data)
    },
    SET_MARKETSTUDY_PRICES_MIN: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_MIN, data)
    },
    SET_MARKETSTUDY_PRICES_MEAN: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_MEAN, data)
    },
    SET_MARKETSTUDY_PRICES_MEDIAN: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_PRICES_MEDIAN, data)
    },


}

const mutations = {

    [RESET_MARKETSTUDY] (state) {
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.id = null
        state.parent_path = null
        state.path = null
        state.appraisal_id = null
        state.description = null
        state.query_ad_type = null
        state.query_distance_km = 1
        state.query_limitdate = null
        state.query_startdate = null
        state.weighing = {
            '0': {
                ad_date: 0,
                property_type: 2,
                quality_of_neighbourhood: 2,
                quality_of_situation: 2,
                quality_of_construction: 2,
                quality_of_realestate: 2,
                adopted_age: 2,
                conservation_status: 5,
                floor_number: 5,
                adopted_area: 2,
                lift: 10
            }
        }
        state.universal_sample_typical_deviation = {
            '0': {
                Xi_total: null,
                Vu_total: null,
                Vi_total: null,
                Vu2_total: null,
                XiVi_total: null,
                Xi2_total: null,
                Vi2_total: null,

                n: null,
                Vu_average: null,
                V_coef: null,
                Vu2_n: null,
                Vu_n_2: null,
                summation_Vu2_n: null,
                summation_Vu_n_2: null,
                g2: null,
                g: null,
                t: null,
                s: null,
                s2: null,
                r: null,
                m: null,
                na: null,
                t_ms: null,
                s2_nas: null,
                a: null,
                b: null
            }
        }
        state.representative_sample_typical_deviation = {
            '0': {
                Xi_total: null,
                Vu_total: null,
                Vi_total: null,
                Vu2_total: null,
                XiVi_total: null,
                Xi2_total: null,
                Vi2_total: null,

                limit_upper: null,
                limit_lower: null,

                n: null,
                Vu_max: null,
                Vu_min: null,
                summation_Vu2_n: null,
                summation_Vu_n_2: null,
                g2: null,
                g: null,
                t: null,
                s: null,
                s2: null,
                r: null,
                m: null,
                na: null,
                t_ms: null,
                s2_nas: null,
                a: null,
                b: null
            }
        }
        state.appraised_points = []
        state.comparable_points = []
        state.regressionline_points = []
        state.market_value = null
        state.market_unit_value = null
        state.realestate_appraisals = {}
        state.prices_estimated_yearly_evolution_pct = null
        state.market_value_evolution_probability_pct = null
        state.offer_production = null
        state.offer_yearly_stock = null
        state.offer_trend = null
        state.demand_level = null
        state.demand_speed_of_sales = null
        state.demand_trend = null
        state.prices_expectancy = null
        state.prices_past_cicles_volatility = null
        state.market_conjuncture = null
        state.market_value_reduction_probability_expectancy = null
        state.prices_max = null
        state.prices_min = null
        state.prices_mean = null
        state.prices_median = null
    },
    [SET_MARKETSTUDY] (state, data) {
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.id = check_undefined(data.id)
        state.parent_path = check_undefined(data.parent_path)
        state.path = check_undefined(data.path)
        state.appraisal_id = check_undefined(data.appraisal_id)
        state.description = check_undefined(data.description)
        state.query_ad_type = check_undefined(data.query_ad_type)
        state.query_distance_km = check_undefined(data.query_distance_km)
        state.query_limitdate = check_undefined(data.query_limitdate)
        state.query_startdate = check_undefined(data.query_startdate)
        state.representative_sample_typical_deviation = check_undefined(data.representative_sample_typical_deviation)
        state.universal_sample_typical_deviation = check_undefined(data.universal_sample_typical_deviation)
        state.weighing = check_undefined(data.weighing)
        state.appraised_points = check_undefined(data.appraised_points)
        state.comparable_points = check_undefined(data.comparable_points)
        state.regressionline_points = check_undefined(data.regressionline_points)
        state.market_value = check_undefined(data.market_value)
        state.market_unit_value = check_undefined(data.market_unit_value)
        state.realestate_appraisals = check_undefined(data.realestate_appraisals)
        state.prices_estimated_yearly_evolution_pct = check_undefined(data.prices_estimated_yearly_evolution_pct)
        state.market_value_evolution_probability_pct = check_undefined(data.market_value_evolution_probability_pct)
        state.offer_production = check_undefined(data.offer_production)
        state.offer_yearly_stock = check_undefined(data.offer_yearly_stock)
        state.offer_trend = check_undefined(data.offer_trend)
        state.demand_level = check_undefined(data.demand_level)
        state.demand_speed_of_sales = check_undefined(data.demand_speed_of_sales)
        state.demand_trend = check_undefined(data.demand_trend)
        state.prices_expectancy = check_undefined(data.prices_expectancy)
        state.prices_past_cicles_volatility = check_undefined(data.prices_past_cicles_volatility)
        state.market_conjunction = check_undefined(data.market_conjunction)
        state.market_conjuncture = check_undefined(data.market_conjuncture)
        state.market_value_reduction_probability_expectancy = check_undefined(data.market_value_reduction_probability_expectancy)
        state.prices_max = check_undefined(data.prices_max)
        state.prices_min = check_undefined(data.prices_min)
        state.prices_mean = check_undefined(data.prices_mean)
        state.prices_median = check_undefined(data.prices_median)

    },
    [SET_MARKETSTUDY_APPRAISAL_ID] (state, data) {
        state.appraisal_id = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_MARKETSTUDY_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_QUERY_AD_TYPE] (state, data) {
        state.query_ad_type = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_QUERY_DISTANCE_KM] (state, data) {
        state.query_distance_km = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_QUERY_LIMITDATE] (state, data) {
        state.query_limitdate = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_QUERY_STARTDATE] (state, data) {
        state.query_startdate = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION] (state, data) {
        state.representative_sample_typical_deviation = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION] (state, data) {
        state.universal_sample_typical_deviation = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING] (state, data) {
        state.weighing = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_AD_DATE] (state, data) {
        state.weighing['0']['ad_date'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE] (state, data) {
        state.weighing['0']['property_type'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD] (state, data) {
        state.weighing['0']['quality_of_neighbourhood'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION] (state, data) {
        state.weighing['0']['quality_of_situation'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION] (state, data) {
        state.weighing['0']['quality_of_construction'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE] (state, data) {
        state.weighing['0']['quality_of_realestate'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE] (state, data) {
        state.weighing['0']['adopted_age'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS] (state, data) {
        state.weighing['0']['conservation_status'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER] (state, data) {
        state.weighing['0']['floor_number'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA] (state, data) {
        state.weighing['0']['adopted_area'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_WEIGHING_LIFT] (state, data) {
        state.weighing['0']['lift'] = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_APPRAISED_POINTS] (state, data) {
        state.appraised_points = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_COMPARABLE_POINTS] (state, data) {
        state.comparable_points = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_REGRESSIONLINE_POINTS] (state, data) {
        state.regressionline_points = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_MARKET_VALUE] (state, data) {
        state.market_value = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_MARKET_UNIT_VALUE] (state, data) {
        state.market_unit_value = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_REALESTATE_APPRAISALS] (state, data) {
        state.realestate_appraisals = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT] (state, data) {
        state.prices_estimated_yearly_evolution_pct = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT] (state, data) {
        state.market_value_evolution_probability_pct = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_OFFER_PRODUCTION] (state, data) {
        state.offer_production = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_OFFER_YEARLY_STOCK] (state, data) {
        state.offer_yearly_stock = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_OFFER_TREND] (state, data) {
        state.offer_trend = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DEMAND_LEVEL] (state, data) {
        state.demand_level = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES] (state, data) {
        state.demand_speed_of_sales = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_DEMAND_TREND] (state, data) {
        state.demand_trend = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_EXPECTANCY] (state, data) {
        state.prices_expectancy = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY] (state, data) {
        state.prices_past_cicles_volatility = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_MARKET_CONJUNCTURE] (state, data) {
        state.market_conjuncture = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY] (state, data) {
        state.market_value_reduction_probability_expectancy = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_MAX] (state, data) {
        state.prices_max = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_MIN] (state, data) {
        state.prices_min = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_MEAN] (state, data) {
        state.prices_mean = data
        state.dirty = true
    },
    [SET_MARKETSTUDY_PRICES_MEDIAN] (state, data) {
        state.prices_median = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    marketstudy: state => {
        return state
    },
    weighing: state => {
        return state.weighing
    },
    representative_sample_typical_deviation: state => {
        return state.representative_sample_typical_deviation
    },
    universal_sample_typical_deviation: state => {
        return state.universal_sample_typical_deviation
    },
    appraised_points: state => {
        return state.appraised_points
    },
    comparable_points: state => {
        return state.comparable_points
    },
    regressionline_points: state => {
        return state.regressionline_points
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/marketstudy/marketstudy.js